module.exports = __webpack_public_path__ + "img/BannerNew.8509f641.png";